import { UserRole } from 'dy-frontend-http-repository/lib/data/enums';

// Member Reports follow the signed-in user's role. Must stay in sync with the backend
// ALLOWED_ROLES gate in TimeTracking/Report/Get.php.
const ALLOWED_REPORTS_ROLES = [
    UserRole.CORE_ROOT,
    UserRole.CORE_ADMIN,
    UserRole.CORE_PLATFORM_DEV,
    UserRole.CORE_OPERATIONS_MANAGER,
    UserRole.CORE_CREATIVE_DIRECTOR,
];

export default ALLOWED_REPORTS_ROLES;
